import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';

Vue.config.productionTip = false;

//BootstrapVue
import './assets/css/bootstrap.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/datepicker3.css';
import './assets/css/styles.css';
import './assets/js/jquery-3.3.1';
import './assets/js/bootstrap.min.js';

//Estilos
import '../public/my-style.css';
import '../public/animate.css';
import 'vuejs-noty/dist/vuejs-noty.css';
import 'vue-loading-overlay/dist/vue-loading.css';

//Modulos
import VueNoty from 'vuejs-noty';
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm.js';
import VueMaterial from 'vue-material';
import VueCurrencyFilter from 'vue-currency-filter';
import firebase from 'firebase';
Vue.use(VueMaterial);
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
Vue.use(Datetime);
Vue.use(Antd);
Vue.use(DatatableFactory);
Vue.use(VueNoty, {
  timeout: 5000,
  progressBar: true,
  layout: 'topRight',
  theme: 'metroui',
});
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
});

const config = {
  apiKey: 'AIzaSyCQrKW8_OuptN9P_W-xdch7TZSRLJrvpnE',
  authDomain: 'tarjetasapp01.firebaseapp.com',
  databaseURL: 'https://tarjetasapp01.firebaseio.com',
  projectId: 'tarjetasapp01',
  storageBucket: 'gs://tarjetasapp01.appspot.com/',
  messagingSenderId: '12017154265',
  appId: '1:12017154265:web:0bda86ef75f5cc28',
};

import WsPlugin from 'adonis-vue-websocket';
Vue.use(WsPlugin, { adonisWS: window.adonis.Ws });
// import Ws from '@adonisjs/websocket-client';
// import WsPlugin from 'adonis-vue-websocket';
// Vue.use(WsPlugin, { adonisWS: Ws });

firebase.initializeApp(config);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
